export default __webpack_public_path__ + "static/10_35-a12bf19cbd45771742ba72f41d1ff7fd.png";